// Copyright 2020 Sorama B.V.

import { autoinject, DOM } from "aurelia-framework";
import { IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { IWorkflowModuleCatalog } from "catalogs/IWorkflowModuleCatalog";
import { HelpWorkflowModuleCatalog } from "catalogs/WorkflowModuleCatalog/HelpWorkflowModuleCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { IWorkflowModuleController } from "libraries/WorkflowFramework/Interfaces/IWorkflowRouter";
import { WorkflowModuleController } from "libraries/WorkflowFramework/WorkflowRouter/WorkflowModuleController";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";

@autoinject
export class HomeView {
    protected selectedTopic: IGuidanceTopic;
    protected htmlSource: string;
    protected currentModule: IWorkflowModuleController;

    public get modules(): IGuidanceTopic {
        return this.moduleCatalog.getWorkflowModules(WorkflowModuleType.Help) as unknown as IGuidanceTopic;
    }

    constructor(
        private readonly shellviewManager: ShellViewManager,
        private readonly moduleCatalog: IWorkflowModuleCatalog
    ) {}

    public openTopic(topic: IGuidanceTopic): Promise<void> {
        return this.shellviewManager.closeRightSideBar().then(() => {
            return this.shellviewManager.openRightSideBarHelp(topic.name);
        });
    }

    public editTopic(topic: IGuidanceTopic): void {
        this.currentModule = new WorkflowModuleController(
            undefined,
            HelpWorkflowModuleCatalog.HelpModule,
            -10000,
            null
        );

        this.openTopic(topic).then(() => {
            this.selectedTopic = topic;
            const element = DOM.getElementById("help-module-instance");
            this.htmlSource = element.innerHTML;
        });
    }
}
